import React from "react";

// @context TGW-2195 イベント作成ページのAIモーダル3つ（一言から作る／写真から読み取る／文章を添削する）は
//   Bootstrapの旧様式（card bg-gray / shadow-sm bg-white container / a-button）が混在し見た目がバラバラだったため、
//   共通の見た目・構造をここに部品化して3モーダルから使う。API呼び出し・state・反映処理はモーダル側のまま変えない。

export const aiInputStyle = {
  width: "100%",
  boxSizing: "border-box",
  border: "1px solid #ECECEE",
  borderRadius: 12,
  padding: "12px 14px",
  fontSize: 15,
  color: "#333",
  background: "#fff",
};

export const AiModalBody = ({ title, description, children }) => (
  <div
    style={{
      background: "#fff",
      maxWidth: 560,
      margin: "0 auto",
      padding: "64px 20px 40px",
      boxSizing: "border-box",
    }}
  >
    <style>{`
      .tg-ai-input:focus { border-color: #FF6467; outline: none; }
      .tg-ai-input::placeholder { color: #BCC1C6; }
      .tg-ai-row-2col { display: flex; gap: 12px; }
      .tg-ai-row-2col > div { flex: 1; min-width: 0; }
      @media (max-width: 480px) {
        .tg-ai-row-2col { flex-direction: column; gap: 0; }
      }
    `}</style>
    <p style={{ fontSize: 18, fontWeight: 800, color: "#333", margin: 0 }}>{title}</p>
    {description && (
      <p style={{ fontSize: 13, color: "#666", lineHeight: 1.6, margin: "6px 0 20px" }}>
        {description}
      </p>
    )}
    {children}
  </div>
);

export const AiField = ({ label, htmlFor, action, children }) => (
  <div style={{ marginBottom: 16 }}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 8,
      }}
    >
      <label htmlFor={htmlFor} style={{ fontSize: 12, fontWeight: 800, color: "#666", margin: 0 }}>
        {label}
      </label>
      {action}
    </div>
    {children}
  </div>
);

export const AiPrimaryButton = ({ disabled, onClick, children, type = "button" }) => (
  <button
    type={type}
    disabled={disabled}
    onClick={onClick}
    style={{
      width: "100%",
      height: 48,
      borderRadius: 12,
      border: "none",
      background: disabled ? "#ECECEE" : "#FF6467",
      color: disabled ? "#8B9097" : "#fff",
      fontSize: 15,
      fontWeight: 800,
      boxShadow: "none",
      cursor: disabled ? "default" : "pointer",
    }}
  >
    {children}
  </button>
);

export const AiTextButton = ({ onClick, children, style }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      background: "none",
      border: "none",
      padding: 0,
      color: "#FF6467",
      fontSize: 13,
      fontWeight: 700,
      cursor: "pointer",
      ...style,
    }}
  >
    {children}
  </button>
);

export const AiResultHeader = ({ title, note }) => (
  <div style={{ borderTop: "1px solid #ECECEE", marginTop: 24, paddingTop: 24, marginBottom: 24 }}>
    <p style={{ fontSize: 14, fontWeight: 800, color: "#333", margin: 0 }}>{title}</p>
    {note && <p style={{ fontSize: 12, color: "#8B9097", margin: "4px 0 0" }}>{note}</p>}
  </div>
);
